import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { day, days, hourAbbr, hoursAbbr, minutesAbbr } from './messages'

export function getDifferenceInMinutesToNow(startTime) {
  var start = moment(moment.unix(startTime))
  var end = moment(Date.now())
  var duration = moment.duration(end.diff(start))
  return Math.floor(duration.asMinutes()) === 0
    ? 1
    : Math.floor(duration.asMinutes())
}

export function getDateDisplay(timestamp, assignment) {
  const minutesAgo = getDifferenceInMinutesToNow(timestamp)
  const daysAgo = getDaysAgoFromMinutes(minutesAgo)

  if (minutesAgo < 60) {
    return (
      <FormattedMessage
        id={'MinuteDateDisplay'}
        defaultMessage={'{val} {minute}'}
        values={{
          val: minutesAgo,
          minute: minutesAbbr
        }}
      />
    )
  } else if (minutesAgo >= 60 && minutesAgo < 1440) {
    return (
      <FormattedMessage
        id={'HourDateDisplay'}
        defaultMessage={'{val} {hour}'}
        values={{
          val: Math.floor(minutesAgo / 60),
          hour: Math.floor(minutesAgo / 60) > 1 ? hoursAbbr : hourAbbr
        }}
      />
    )
  } else if (daysAgo <= 7 || !assignment) {
    return (
      <FormattedMessage
        id={'DayDateDisplay'}
        defaultMessage={'{val} {day}'}
        values={{
          val: daysAgo,
          day: daysAgo > 1 ? days : day
        }}
      />
    )
  } else {
    return moment.unix(timestamp).format('DD MMMM YYYY').toString()
  }
}

export function getDaysAgoFromMinutes(minutesAgo) {
  return Math.floor(minutesAgo / 1440)
}

export function getCurrentYear() {
  return new Date().getFullYear()
}

export function isUnixTimestamp(datetime) {
  return !/[a-z]/i.test(datetime)
}

export const getMinutesFromSeconds = seconds => Math.floor(seconds / 60)

export const getRemainingSecondsFromTotalTime = totalTime => totalTime % 60

export const fancyTimeFormat = seconds => {
  // Hours, minutes and seconds
  let hrs = ~~(seconds / 3600)
  let mins = ~~((seconds % 3600) / 60)
  let secs = ~~seconds % 60

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = ''

  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
  }

  ret += '' + mins + ':' + (secs < 10 ? '0' : '')
  ret += '' + secs
  return ret
}



// WEBPACK FOOTER //
// ./src/utils/time.js